module.exports = __webpack_public_path__ + "img/symbol_pfeilundbogen.0652699.webp";